import { useAppDispatch } from "core/utils";
import { useParams } from "react-router";

import { AcquirerToVirtualCreateForm } from "src/app/features/Acquirer/components/forms/AcquirerToVirtualCreateForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { ResourceName, ResourceVariant } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../core/setup/redux/state/tabs/tabState";

export const AcquirerToVirtualCreateFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const { id } = useParams();

    const dispatch = useAppDispatch();
    const setTabsDefaultBeforeBack = () => dispatch(setDefaultActiveKey("acquirers_physicalAcquirers"));

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.acquirersPhysicalToVirtualCreateFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <CancelButton
                        isDisabled={false}
                        url={`${BASE_PATH}/${ResourceName.ACQUIRER}/${ResourceVariant.VIRTUAL}/${FORM_ACTION.EDIT}/${id}`}
                        onBeforeNavigate={setTabsDefaultBeforeBack}
                    />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <AcquirerToVirtualCreateForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
